<template>
  <div :data-gallery-id="albumId" class="yotpo yotpo-pictures-widget"></div>
</template>

<script setup lang="ts">
useYotpo()
const { albumId } = defineProps<{ albumId: string }>()
</script>
